//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictonary'
import moment from 'moment'

export default {
  props: {
    base: {
      default: ''
    },
    value: ''
  },
  data: function () {
    return {
      minute: undefined,
      minuteOptions: [
        { value: 5, label: '5分钟' },
        { value: 10, label: '10分钟' },
        { value: 15, label: '15分钟' },
        { value: 20, label: '20分钟' },
        { value: 25, label: '25分钟' },
        { value: 30, label: '30分钟' },
        { value: 35, label: '35分钟' },
        { value: 40, label: '40分钟' },
        { value: 45, label: '45分钟' },
        { value: 50, label: '50分钟' },
        { value: 55, label: '55分钟' },
        { value: 60, label: '60分钟' }
      ],
      currentValue: ''
    }
  },
  watch: {
    base: {
      handler (val) {
        // console.log('watch.base', true)
        // console.log('val', val)
        // console.log('this.currentValue', this.currentValue)
        if (val && this.currentValue) {
          let diff = moment.preciseDiff(moment(`2000-01-01 ${this.currentValue}`), moment(`2000-01-01 ${val}`), true)
          let minute = diff.minutes
          if (diff.minutes === 0 && diff.hours === 1) {
            minute = 60
          }
          // console.log('minute', minute)
          // console.log('this.minute', this.minute)
          if (this.minute !== minute) {
            this.minute = minute
          } else {
            let v = moment(`2000-01-01 ${val}`).add(this.minute, 'minutes').format('HH:mm:ss')
            if (v !== this.currentValue) {
              this.currentValue = v
            }
          }
        } else if (val && this.minute) {
          let v = moment(`2000-01-01 ${val}`).add(this.minute, 'minutes').format('HH:mm:ss')
          if (v !== this.currentValue) {
            this.currentValue = v
          }
        }
      },
      immediate: true
    },
    value: {
      handler (val) {
        // console.log('watch.value', true)
        // console.log('val', val)
        // console.log('base', this.base)
        if (!_.isEmpty(val) && this.base) {
          let diff = moment.preciseDiff(moment(`2000-01-01 ${val}`), moment(`2000-01-01 ${this.base}`), true)
          let minute = diff.minutes
          if (diff.minutes === 0 && diff.hours === 1) {
            minute = 60
          }
          if (this.minute !== minute) {
            this.minute = minute
          }
        } else {
          // console.log('here', true)
          this.minute = undefined
        }
      },
      immediate: true
    },
    minute: {
      handler (val) {
        // console.log('watch.minute.val', val)
        if (val && this.base) {
          let v = moment(`2000-01-01 ${this.base}`).add(val, 'minutes').format('HH:mm:ss')
          // console.log('val', val)
          // console.log('v', v)
          // console.log('currentValue', this.currentValue)
          if (v !== this.currentValue) {
            this.currentValue = v
          }
        } else {
          this.currentValue = ''
        }
      },
      immediate: true
    },
    currentValue: {
      handler (val) {
        if (val !== this.value) {
          this.$emit('input', val)
        }
      },
      immediate: true
    },
  },
  components: {

  },
  mounted () {

  },
  methods: {

  }
}
